// src/components/LoginPage.js
import React, { useState, useEffect } from "react";
import { useAuth } from "../useAuth";
import { useNavigate } from "react-router-dom";
import bgImage from "../assets/maritime-bg.jpg"; // ✅ import local image

function LoginPage() {
  const { login, currentUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      setLoading(true);
      await login(email, password);
      // 🚀 Navigation handled below in useEffect
    } catch (err) {
      console.error("Login error:", err.code, err.message);
      setError("Invalid email or password. Please try again.");
      setLoading(false);
    }
  };

  // 🚀 Auto-redirect once user is signed in
  useEffect(() => {
    if (currentUser) {
      navigate("/dashboard");
    }
  }, [currentUser, navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url(${bgImage})`, // ✅ use imported image
        backgroundSize: "cover",
        backgroundPosition: "center",
        fontFamily: "Montserrat, sans-serif",
        position: "relative",
      }}
    >
      {/* Login Card */}
      <div
        style={{
          background: "rgba(34, 40, 54, 0.85)",
          backdropFilter: "blur(6px)",
          padding: "40px",
          borderRadius: "16px",
          boxShadow: "0 8px 25px rgba(0, 147, 255, 0.3)",
          width: "350px",
          textAlign: "center",
          color: "#DCE4F2",
        }}
      >
        <h2 style={{ marginBottom: "10px" }}>Sign In</h2>
        <p style={{ fontSize: "14px", marginBottom: "20px", color: "#A0AEC0" }}>
          Secure access to Equity Insight’s Peer Import Dashboard
        </p>

        {error && (
          <div
            style={{
              backgroundColor: "#FF4C4C",
              color: "white",
              padding: "10px",
              borderRadius: "6px",
              marginBottom: "15px",
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              width: "100%",
              padding: "12px",
              marginBottom: "15px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{
              width: "100%",
              padding: "12px",
              marginBottom: "15px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          />

          <div style={{ textAlign: "left", marginBottom: "15px" }}>
            <label style={{ fontSize: "14px", color: "#DCE4F2" }}>
              <input type="checkbox" style={{ marginRight: "6px" }} /> Remember Me
            </label>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "12px",
              background: loading ? "#0073cc" : "#0093FF",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: loading ? "not-allowed" : "pointer",
              transition: "background 0.3s ease",
            }}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <div style={{ marginTop: "20px" }}>
          <a
            href="/forgot-password"
            style={{
              color: "#00D160",
              textDecoration: "none",
              fontSize: "14px",
            }}
          >
            Forgot Password?
          </a>
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          background: "rgba(0,0,0,0.6)",
          color: "#DCE4F2",
          textAlign: "center",
          padding: "10px 0",
          fontSize: "14px",
        }}
      >
        Copyright © 2026. Equity Insight. All Rights Reserved.
      </div>
    </div>
  );
}

export default LoginPage;
